import { render } from "./MobileApp.vue?vue&type=template&id=28009139&scoped=true"
import script from "./MobileApp.vue?vue&type=script&lang=js"
export * from "./MobileApp.vue?vue&type=script&lang=js"

import "./MobileApp.vue?vue&type=style&index=0&id=28009139&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-28009139"]])

export default __exports__